(ns teamoesterreich.user-mode.prevent.trigger-helper2
  (:require
    [reagent-material-ui.components :as mui]
    [reagent-material-ui.icons.done :refer [done]]
    [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
    [reagent.core :as r]
    [teamoesterreich.store :as store]
    [teamoesterreich.user-mode.actions :as a]
    [teamoesterreich.user-mode.prevent.evaluate :as evaluate]
    [teamoesterreich.util.log :as log]
    ))

(defn trigger-modal []
  (let [state-cs (r/atom {})
        show-trigger-dialog-cs (r/cursor store/app-state [:state :show-trigger-dialog])
        show-triggers-cs (r/cursor store/app-state [:state :show-triggers])]
    (log/out (str "trigger-popup " @show-trigger-dialog-cs " ") (clj->js @show-triggers-cs))
    [mui/modal

     {
      :ariaLabelledby  "simple-modal-title"
      :ariaDescribedby "simple-modal-description"
      :style           {:display        "flex"
                        :marginRight    "auto"
                        :marginLeft     "auto"
                        :alignItems     "center"
                        :justifyContent "center"}
      :open            (or @show-trigger-dialog-cs false)

      }
     (when @show-trigger-dialog-cs
       [:div
        {
         :class "modal"
         :style {:width 600}}
        [:h4 "Einkaufs-/To-Do-Listeinträge"]

        [:br]

        (mapv (fn [[triggerId trigger]]
                ;(log/out "trigger ########### " (clj->js trigger))
                (mui/checkbox {:iconStyle {:fill "black"}
                               :label     (str (:name trigger)
                                               (get {"shopping" " (Einkauf)" "action" " (Aktion)"} (:type trigger)))
                               :checked   (not (false? (get @state-cs triggerId)))
                               :on-check  (fn [e v] (swap! state-cs assoc triggerId v))
                               }))
              @show-triggers-cs)
        [:br]
        [mui/button
         {:color     "primary"
          :variant   "contained"
          :startIcon (r/as-element [keyboard-arrow-left])
          :style     {:marginRight 50}
          :onClick   #(reset! show-trigger-dialog-cs false)
          }
         "Abbrechen"]
        [mui/button
         {:style     {:float "right"}
          :variant   "contained"
          :startIcon (r/as-element [done])
          :onClick   (fn []
                       (doseq [[triggerId trigger] (or @show-triggers-cs [])]
                         (when (not (false? (get @state-cs triggerId)))
                           ;(log/out "trigger process ########### " (clj->js trigger))
                           (case (:type trigger)
                             "shopping" (a/add-shopping-item (str (:locationId trigger) "_" triggerId) trigger)
                             "action" (a/add-action-list-item (str (:locationId trigger) "_" triggerId) trigger))
                           ))
                       (reset! show-trigger-dialog-cs false)
                       )
          }
         "Ok"]]
       )]))


(defn trigger-add-show [ao-path locationId answer-option answer-obj triggerId trigger]
  (log/out "trigger-do " (clj->js answer-obj) (clj->js trigger))
  (swap! (r/cursor store/app-state [:state :show-triggers])
         (fn [o] (merge o [triggerId {:description (:description trigger)
                                      :name        (:name trigger)
                                      :unit        (:unit trigger)
                                      :type        (:type trigger)
                                      :quantity    (float (if ((keyword "quantity$dynamic") trigger)
                                                            (evaluate/calculate-and-set ((keyword "quantity$dynamic") trigger))
                                                            (:quantity trigger)))
                                      :done        false
                                      :locationId  locationId
                                      :triggerId   triggerId
                                      :reference   (:answer-option answer-obj)
                                      :ao-path     (str ao-path)
                                      :aot-path    (str ao-path "/triggers/" triggerId)
                                      }])))
  (reset! (r/cursor store/app-state [:state :show-trigger-dialog]) true))


(defn trigger-check-checkbox [ao-path locationId answer-option answer-obj triggerId trigger]
  (log/out "trigger-check-checkbox " (clj->js answer-obj) (clj->js trigger))
  (when (= (:trigger-answer_checkbox trigger) (:answer_checkbox answer-obj))
    (trigger-add-show ao-path locationId answer-option answer-obj triggerId trigger)))

(defn trigger-check-radio [ao-path locationId answer-option answer-obj triggerId trigger]
  (log/out "trigger-check-radio " (clj->js answer-obj) (clj->js trigger))
  (when (= (:trigger-answer_radio trigger) (:answer_radio answer-obj))
    (trigger-add-show ao-path locationId answer-option answer-obj triggerId trigger)))

(defn trigger-check-numeric [ao-path locationId answer-option answer-obj triggerId trigger]
  (log/out "trigger-check-numeric " (clj->js answer-obj) (clj->js trigger)))

(defn trigger-check-text [ao-path locationId answer-option answer-obj triggerId trigger]
  (log/out "trigger-check-text " (clj->js answer-obj) (clj->js trigger)))

(defn trigger-check-decimal [ao-path locationId answer-option answer-obj triggerId trigger]
  (log/out "trigger-check-decimal " (clj->js answer-obj) (clj->js trigger)))

(defn trigger-check [ao-path locationId answer-option answer-obj triggerId trigger]
  ;(log/out "trigger-check " (clj->js answer-obj) (clj->js trigger))
  (case (:type answer-option)
    "image" nil
    "radio_group" nil
    "radio_button" (trigger-check-radio ao-path locationId answer-option answer-obj triggerId trigger)
    "checkbox" (trigger-check-checkbox ao-path locationId answer-option answer-obj triggerId trigger)
    "text" (trigger-check-text ao-path locationId answer-option answer-obj triggerId trigger)
    "numeric" (trigger-check-numeric ao-path locationId answer-option answer-obj triggerId trigger)
    "decimal" (trigger-check-decimal ao-path locationId answer-option answer-obj triggerId trigger)
    [:div {:style {:font-size "10px" :color "red"}} (str (:type answer-option) "  " (:text answer-option))]))




(defn trigger-all [ao-path locationId ao answer-obj triggers]
  (reset! (r/cursor store/app-state [:state :show-triggers]) nil)
  (doseq [[triggerId trigger] triggers]
    (trigger-check ao-path locationId ao answer-obj triggerId trigger))
  ;(log/out "trigger-all2222 " (clj->js (into [] triggers)))
  )

;(map (fn [[a b]] (log/out b)) (:triggers (get-in (deref store/store) [:questionnaires "5b276a81-093c-49af-a597-feeeb9198681" :questions "5b276b4b-5c71-4580-a175-7896067cb265" :answer-options "5b279626-94eb-4b2e-86a7-bce0c41153c7"])))
;(get-in (deref store/store) [:state :show-triggers])

